"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIpInCidr = exports.isValidIp = void 0;
var isValidIp = function (ip) {
    // CIDR記法をチェック
    if (ip.includes("/")) {
        var _a = __read(ip.split("/"), 2), ipAddress = _a[0], subnet = _a[1];
        var subnetNum = parseInt(subnet, 10);
        // サブネットマスクの妥当性チェック（0-32）
        if (isNaN(subnetNum) || subnetNum < 0 || subnetNum > 32) {
            return false;
        }
        // IPアドレス部分の妥当性チェック
        return /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ipAddress);
    }
    // 通常のIPアドレスをチェック
    return /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ip);
};
exports.isValidIp = isValidIp;
/**
 * IPアドレスがCIDRブロック内に含まれるかチェックする
 * @param ip チェック対象のIPアドレス
 * @param cidr CIDRブロック（例: "192.168.1.0/24"）
 * @returns IPがCIDRブロック内にあるかどうか
 */
var isIpInCidr = function (ip, cidr) {
    if (!cidr.includes("/")) {
        // CIDR記法でない場合は完全一致
        return ip === cidr;
    }
    var _a = __read(cidr.split("/"), 2), network = _a[0], subnetStr = _a[1];
    var subnet = parseInt(subnetStr, 10);
    // IPアドレスを32ビット整数に変換
    var ipToInt = function (ipStr) {
        return ipStr.split(".").reduce(function (acc, octet) { return (acc << 8) + parseInt(octet, 10); }, 0) >>> 0;
    };
    var ipInt = ipToInt(ip);
    var networkInt = ipToInt(network);
    // サブネットマスクを作成
    var mask = (0xffffffff << (32 - subnet)) >>> 0;
    // ネットワークアドレスが一致するかチェック
    return (ipInt & mask) === (networkInt & mask);
};
exports.isIpInCidr = isIpInCidr;
